import React, { useState } from 'react';
import FileExplorerContainer from '../EditorContainer/FileExplorerContainer';
import CollabPanel from './CollabPanel';
import { FileItem } from '../../types/files';
import { FaRegFile, FaUsers } from 'react-icons/fa';
import './SidebarContainer.css';
import { useCollab } from '../../contexts/CollabContext';

interface SidebarContainerProps {
  onFileClick: (file: FileItem, options?: { preview?: boolean }) => void;
  isSidebarVisible: boolean;
  onToggleSidebar: () => void;
  onFileDeleted: (file: FileItem) => void;
  onFileRenamed: (oldFile: FileItem, newFile: FileItem) => void;
  previewTab: FileItem | null;
}

interface SessionUser {
  name: string;
  color: string;
}

const SidebarContainer: React.FC<SidebarContainerProps> = (props) => {
  const collab = useCollab();

  const [activeCollabTab, setActiveCollabTab] = useState<'files' | 'collab'>('files');
  const [isJoinModalOpen, setJoinModalOpen] = useState(false);

  // Session state
  const [copied, setCopied] = useState(false);

  // Session logic
  const handleHostSessionModal = async () => {
    await collab.hostSession();
  };

  const handleJoinSessionModal = () => {
    setJoinModalOpen(true);
  };
  
  // Join session
  const handleJoinSessionSubmit = async (sessionId: string) => {
    const success = await collab.joinSession(sessionId);
    if (success) {
      setJoinModalOpen(false);
    }
    // If not successful, do not close the modal so error can be shown
  };

  const handleCopySessionId = () => {
    if (collab.sessionId) {
      navigator.clipboard.writeText(collab.sessionId);
      setCopied(true);
      setTimeout(() => setCopied(false), 1200);
    }
  };

  return (
    <div style={{ width: '100%', display: 'flex', flexDirection: 'column', height: '100%' }}>
      <div style={{ width: '100%', display: 'flex', flexDirection: 'row', alignItems: 'center', background: '#252526', padding: '0 8px', height: 48, justifyContent: 'center' }}>
        <button
          className={`sidebar-tab-btn${activeCollabTab === 'files' ? ' active' : ''}`}
          onClick={() => setActiveCollabTab('files')}
          title="File Explorer"
        >
          <FaRegFile size={16} color="#bdbdbd" />
        </button>
        <button
          className={`sidebar-tab-btn${activeCollabTab === 'collab' ? ' active' : ''}`}
          onClick={() => setActiveCollabTab('collab')}
          title="Session"
        >
          <FaUsers size={16} color="#bdbdbd" />
        </button>
      </div>
      <div style={{ flex: 1, background: '#181a1b', overflow: 'hidden' }}>
        {activeCollabTab === 'files' && <FileExplorerContainer {...props} />}
        {activeCollabTab === 'collab' && (
          <CollabPanel
            isJoinModalOpen={isJoinModalOpen}
            setJoinModalOpen={setJoinModalOpen}
            users={collab.users}
            connection={collab.connection}
            copied={copied}
            setCopied={setCopied}
            joinError={collab.collabErrors}
            handleHostSessionModal={handleHostSessionModal}
            handleJoinSessionModal={handleJoinSessionModal}
            handleJoinSessionSubmit={handleJoinSessionSubmit}
            handleCopySessionId={handleCopySessionId}
          />
        )}
      </div>
    </div>
  );
};

export default SidebarContainer; 